import { render } from "./Pets.vue?vue&type=template&id=944ea54c"
import script from "./Pets.vue?vue&type=script&lang=js"
export * from "./Pets.vue?vue&type=script&lang=js"

import "./Pets.vue?vue&type=style&index=0&id=944ea54c&lang=css"

import exportComponent from "C:\\Users\\smart\\OneDrive\\Desktop\\Final Projects\\pet-shelter - global\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__